module.exports = __webpack_public_path__ + "static/media/66.15ea7c96.jpg";